<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-5">Compute the following mathematical operations:</p>

      <p class="mb-3">
        <stemble-latex
          content="$\displaystyle{\text{a) }\frac{(13.67 \pm 0.02)(120.4\pm0.2)}{4.623\pm0.006}}$"
        />
      </p>

      <calculation-input
        v-model="inputs.input1a"
        class="mb-7 d-inline-block"
        style="max-width: 319px"
        :disabled="!allowEditing"
      />
      <stemble-latex content="$\pm$" class="px-3" />
      <calculation-input
        v-model="inputs.input1u"
        class="mb-7 d-inline-block"
        style="max-width: 130px"
        :disabled="!allowEditing"
      />

      <p class="mb-3">
        <stemble-latex content="$\text{b) } \log(5.00 \pm 0.004)$" />
      </p>

      <calculation-input
        v-model="inputs.input2a"
        class="mb-7 d-inline-block"
        style="max-width: 319px"
        :disabled="!allowEditing"
      />
      <stemble-latex content="$\pm$" class="px-3" />
      <calculation-input
        v-model="inputs.input2u"
        class="mb-7 d-inline-block"
        style="max-width: 130px"
        :disabled="!allowEditing"
      />

      <p class="mb-3">
        <stemble-latex content="$\text{c) antilog}[51.55(\pm0.08)]$" />
      </p>

      <calculation-input
        v-model="inputs.input3a"
        class="mb-7 d-inline-block"
        style="max-width: 319px"
        :disabled="!allowEditing"
      />
      <stemble-latex content="$\pm$" class="px-3" />
      <calculation-input
        v-model="inputs.input3u"
        class="mb-7 d-inline-block"
        style="max-width: 130px"
        :disabled="!allowEditing"
      />

      <p class="mb-3">
        <stemble-latex
          content="$\displaystyle{\text{d) } \frac{20.6 (\pm 0.2) - 0.750(\pm 0.008)}{0.0411(\pm 0.002)}}$"
        />
      </p>

      <calculation-input
        v-model="inputs.input4a"
        class="d-inline-block"
        style="max-width: 319px"
        :disabled="!allowEditing"
      />
      <stemble-latex content="$\pm$" class="px-3" />
      <calculation-input
        v-model="inputs.input4u"
        class="d-inline-block"
        style="max-width: 130px"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'ChemUPEI2210A1Q3',
  components: {
    CalculationInput,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1a: null,
        input2a: null,
        input3a: null,
        input4a: null,

        input1u: null,
        input2u: null,
        input3u: null,
        input4u: null,
      },
    };
  },
};
</script>
